import { IonText } from '@ionic/react';
import React from 'react';

import styles from './PendingText.module.css';
import classNames from 'classnames';
export interface PendingTextProps {
	small?: boolean;
}
export const PendingText: React.FC<PendingTextProps> = ({ small }: PendingTextProps) => {
	return (
		<IonText className={classNames(styles.PendingText, small ? styles.small : '')}>
			<span>{small ? 'Pending' : 'Pending approval'}&hellip;</span>
		</IonText>
	);
};
